import styled, { keyframes } from "styled-components";
import { Link } from "react-router-dom";
import Cart from "./Cart";

export const BRAND = "Alumen";

export default function Nav() {
  return (
    <Bar>
      <Mark to="/">{BRAND}</Mark>
      <Right>
        <NavLink to="/">Koleksioni</NavLink>
        <Cart />
      </Right>
    </Bar>
  );
}

const drop = keyframes`
  from { opacity: 0; transform: translateY(-12px); }
  to   { opacity: 1; transform: translateY(0); }
`;

const Bar = styled.header`
  position: sticky;
  top: 0;
  z-index: 20;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
  padding: 14px clamp(20px, 5vw, 64px);
  background: color-mix(in srgb, var(--bg) 82%, transparent);
  backdrop-filter: blur(14px);
  border-bottom: 1px solid var(--line);
  transition:
    background var(--t-theme) var(--ease),
    border-color var(--t-theme) var(--ease);
  animation: ${drop} 800ms cubic-bezier(0.22, 0.61, 0.36, 1) both;
`;

const Mark = styled(Link)`
  font-family: "Instrument Serif", Georgia, serif;
  font-size: 22px;
  color: inherit;
  text-decoration: none;
  white-space: nowrap;
`;

const Right = styled.div`
  display: flex;
  align-items: center;
  gap: clamp(12px, 3vw, 30px);
`;

const NavLink = styled(Link)`
  font-size: 11px;
  letter-spacing: 0.2em;
  text-transform: uppercase;
  color: var(--ink-soft);
  text-decoration: none;

  &:hover {
    color: var(--ink);
  }

  @media (max-width: 560px) {
    display: none;
  }
`;
